<template>
  <div class="flex justify-center items-start min-h-screen p-4 sm:p-6"
       :style="{ backgroundColor: localCompany?.colorpage || '#D3D3D3' }">
    <!-- Removido py-12 e ajustado a estrutura flex -->
    <div class="bg-white shadow-lg rounded-lg p-4 w-full max-w-sm sm:max-w-md md:max-w-lg min-h-[390px] flex flex-col justify-between">
      
      <!-- Container principal com todo o conteúdo exceto o footer -->
      <div>
        <!-- Logo -->
        <div class="logo-container mb-8">
          <img
            v-if="localCompany?.logofilename"
            :src="`${apiBaseUrl}/static/logos/${localCompany.logofilename}`"
            alt="Logo da Empresa"
            class="w-40 h-auto mx-auto"
          />
        </div>

        <!-- Nome da empresa -->
        <h1
          v-if="localCompany && localCompany.hide_name === false"
          class="text-gray-700 font-semibold text-xl sm:text-2xl md:text-3xl mb-8 text-center"
        >
          {{ localCompany.name }}
        </h1>

        <!-- Mensagem de agradecimento -->
        <h1 class="text-gray-700 font-semibold text-xl sm:text-2xl md:text-3xl mb-4 text-center">
          Muito obrigado!
        </h1>
        
        <p class="text-gray-600 text-lg text-center mb-4">
          Agradecemos sua participação! Sua opinião nos ajuda a melhorar continuamente.
        </p>
      </div>

      <!-- Rodapé - agora vai ficar sempre na parte inferior -->
      <div class="text-xs text-gray-500 text-right mt-auto pt-4">
        <p v-if="localCompany?.footer_credit">
          Feito com ❤️ por Avalioo
        </p>
      </div>

    </div>
  </div>
</template>




<script>
import { useCompanyStore } from '@/stores/company';

export default {
  name: 'ThankYouPage',
  props: ['company'],
  data() {
    return {
      localCompany: null,
      apiBaseUrl: process.env.VUE_APP_API_URL,
    };
  },
  
  created() {
    // Recupera os dados da empresa da query
    //const companyData = this.$route.query.company;  //usado para query
    
    const companyStore = useCompanyStore();
    this.localCompany = companyStore.tempCompany;
    // console.log(">>>> this.company: ", this.localCompany);
    // if (this.company) {
    //   this.localCompany = JSON.parse(atob(this.company)); //atob = descriptografar
    //   console.log(">>>> this.localCompany: ", this.localCompany);
    // }
  },
  mounted() {
    // console.log('Dados da empresa:', this.localCompany);
  }
};
</script>